/**
 * Register Roboto font in jsPDF for full UTF-8 support (CO₂, accents, etc.)
 * The TTF files are imported as URLs by Vite, fetched at runtime, and registered.
 */
import { jsPDF } from 'jspdf';

// Vite imports TTF files as URLs (handled by asset pipeline)
import robotoRegularUrl from './Roboto-Regular.ttf?url';
import robotoBoldUrl from './Roboto-Bold.ttf?url';

let fontsRegistered = false;
let regularBase64: string | null = null;
let boldBase64: string | null = null;

async function fetchFontAsBase64(url: string): Promise<string> {
  const response = await fetch(url);
  const buffer = await response.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

/**
 * Load and register Roboto (Regular + Bold) into a jsPDF instance.
 * Call this once before generating the PDF content.
 */
export async function registerRobotoFont(doc: jsPDF): Promise<void> {
  // Cache base64 strings so we only fetch once per session
  if (!regularBase64) {
    regularBase64 = await fetchFontAsBase64(robotoRegularUrl);
  }
  if (!boldBase64) {
    boldBase64 = await fetchFontAsBase64(robotoBoldUrl);
  }

  // Add fonts to the VFS (Virtual File System)
  doc.addFileToVFS('Roboto-Regular.ttf', regularBase64);
  doc.addFileToVFS('Roboto-Bold.ttf', boldBase64);

  // Register fonts
  doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
  doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold');

  fontsRegistered = true;
}

export function isFontsRegistered(): boolean {
  return fontsRegistered;
}
